var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { untracked } from 'mobx';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { runtime } from '../runtime/Runtime';
import { getPackagesNamesForSerialized } from '../../packages/package_resolve';
import { convertSerializedToStoreKey } from '../../utils/utils';
import { deserialize } from '../../utils/serializr/core/deserialize';
export class ModelStream {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get model() {
        return this.parent;
    }
    entityByTypeAndId(type, id) {
        if (type === 'question') {
            const persistentData = runtime.persistent.entityData(type, id).streamedRef;
            if (!persistentData)
                return undefined;
            const missingPackages = getPackagesNamesForSerialized(persistentData).filter(n => !runtime.runtimePackages.packageShelf[n].streamedPackage);
            if (missingPackages.length > 0)
                return undefined;
        }
        return this.getEntityForHandler(runtime.persistent.entityData(type, id));
    }
    getEntityForHandler(handler) {
        if (!handler.streamedRef)
            return undefined;
        const ser = handler.streamedRef;
        const storeKey = `${this.model.id}_${this.model.owner.type}_${this.model.owner.id}_${ser.type}_${ser.id}`;
        if (!runtime.runtimePermissions.hasEditFunctionality) {
            if (runtime.persistent.entityCache.has(storeKey))
                return runtime.persistent.entityCache.get(storeKey);
            const entity = this.getEntityBySerialized(ser);
            runtime.persistent.entityCache.set(storeKey, entity);
            return entity;
        }
        const entityAlreadyInModel = runtime.runtimeSync.syncronizedEntities.get(storeKey);
        if (entityAlreadyInModel) {
            return entityAlreadyInModel;
        }
        const enableSynchronous = true;
        if (enableSynchronous) {
            const entity = untracked(() => this.getEntityBySerialized(ser));
            runtime.runtimeSync.addEntityToSyncronizedEntities(this.model, entity);
            return entity;
        } /*else {
          // OBSOLETE????
    
          if (!runtime.runtimeSync.entityFetchDeduplication.has(storeKey)) {
            runtime.runtimeSync.entityFetchDeduplication.set(storeKey, true);
    
            if (isSynchronouslyDeserializable(ser.type)) {
              const entity = this.getEntityBySerialized(ser);
              runtime.runtimeSync.addEntityToSyncronizedEntities(this.model, entity);
            } else {
              const model = this.model;
              setTimeout(() => {
                const entity = this.getEntityBySerialized(ser);
                console.log('BBBBB', ser, entity);
                runtime.runtimeSync.addEntityToSyncronizedEntities(model, entity);
              }, 10);
            }
          }
          console.log('CCCC', runtime.runtimeSync.syncronizedEntities.get(storeKey));
          return runtime.runtimeSync.syncronizedEntities.get(storeKey); // cleanup cycles
        } */
    }
    getEntityBySerialized(ser) {
        const storeKey = convertSerializedToStoreKey(ser);
        const Entity = runtime.class.serialized_to_EntityClass(ser);
        if (ser.type === 'question') {
            // runtime.test = Date.now();
            console.time(`deserialize ${storeKey}`);
        }
        try {
            const entity = deserialize(Entity, { ...ser, parent: this.model.owner });
            entity.database_serialized = ser;
            if (ser.type === 'question') {
                // runtime.test = 0;
                console.timeEnd(`deserialize ${storeKey}`);
            }
            return entity;
        }
        catch (e) {
            console.error(e);
        }
    }
    createProxy(type) {
        return new Proxy(this, {
            get(modelStream, lookup) {
                return modelStream.entityByTypeAndId(type, lookup);
            },
        });
    }
    get path() {
        return this.createProxy('path');
    }
    get topic() {
        return this.createProxy('topic');
    }
    get question() {
        return this.createProxy('question');
    }
    get bundle() {
        return this.createProxy('bundle');
    }
    /* SONDERFALL */
    get location() {
        return new Proxy(this, this.lookupLocationHandler);
    }
    lookupLocationHandler = {
        get(modelStream, pathURI) {
            if (modelStream.model.available.path[pathURI])
                return modelStream.path[pathURI];
            const topic = canThisPathURIBeATopic(pathURI) ? modelStream.topic[pathURI] : null;
            if (topic !== null)
                return topic;
            return canThisPathURIBeAPath(pathURI) ? modelStream.path[pathURI] : null;
        },
    };
}
__decorate([
    memoize
], ModelStream.prototype, "path", null);
__decorate([
    memoize
], ModelStream.prototype, "topic", null);
__decorate([
    memoize
], ModelStream.prototype, "question", null);
__decorate([
    memoize
], ModelStream.prototype, "bundle", null);
__decorate([
    memoize
], ModelStream.prototype, "location", null);
function isValidLocationPath(pathURI) {
    return typeof pathURI === 'string' && pathURI.length > 10 && pathURI.includes('.');
}
export function canThisPathURIBeAPath(pathURI) {
    return isValidLocationPath(pathURI) && pathURI.split('/').length < 6;
}
export function canThisPathURIBeATopic(pathURI) {
    return isValidLocationPath(pathURI) && pathURI.split('/').length > 4;
}
